import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import VueToastr2 from 'vue-toastr-2'
import 'vue-toastr-2/dist/vue-toastr-2.min.css'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import VModal from 'vue-js-modal'


import {ApiService} from './services/api.service'
import VueLoadScript from 'vue-load-script-plus'
import Datatable from 'vue2-datatable-component'

Vue.use(VModal)
Vue.use(VueLoadScript)
Vue.use(Datatable) // done!
window.toastr = require('toastr');
ApiService.init('https://api.botoffice.com');

import JsonExcel from 'vue-json-excel'

Vue.component('downloadExcel', JsonExcel)
if (store.dispatch('isLoggedIn')) {
    //console.log(store.getters.GET_AUTH_TOKEN);
    ApiService.setHeader(store.getters.GET_AUTH_TOKEN);
}
else
    store.dispatch('UNSET_USER').then(() => {
    });

Vue.config.productionTip = false;
Vue.use(VueToastr2);
Vue.use(VueSweetalert2);

Vue.mixin({


    methods: {
        setTitle(title) {
            if (title) {
                document.title = title;
            }
        },

    },

    beforeDestroy() {
        document.removeEventListener('keyup', this.handler);
    }
})


new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
